{
  "domain": "unforgotten.us.auth0.com",
  "clientId": "jLou9UKEYsRs423BBScYmsj6KX1umsbA"
}
